/**
 * For Confirmation for Clearing Table Analysis
 * Created On: 18-02-2025
 */
//  Generic imports
import React from "react";
import PropTypes from 'prop-types';

//  Motif imports
import MotifModal, { MotifModalHeader, MotifModalBody } from '@ey-xd/motif-react/Modal';
import { MotifModalFooter } from "@ey-xd/motif-react";
import MotifButton from '@ey-xd/motif-react/Button';

//  Icons imports
import iconWarning from '../../../../assets/images/warning.svg';

const ClearTableAnalysis = ({ onClose, handleClearTableAnalysis, clearTableAnalysisFromExcel }) => {
    return (
        <div>
            <MotifModal id="deleteWarningTableModal" show={true} size="sm"
                focusTrapOptions={{
                    tabbableOptions: {
                        displayCheck: 'none',
                    },
                }}
                onClose={onClose}
                className='deleteWarningTableModal confirmModal modalMotifFooterModal'
            >
                <MotifModalHeader
                    className='deleteWarningTableHeader'
                    closeButtonProps={{
                        'aria-label': 'Close',
                        title: 'Close'
                    }}
                >
                    <div className='closeSymbolContainer'>
                        <img className='warningCircle' alt='icon' src={iconWarning} />
                    </div>
                    <div className='deleteTextTable'>Clear Table Analysis</div>
                </MotifModalHeader>
                <MotifModalBody className='deleteWarningTableBody'>
                    <React.Fragment key=".0">

                        <div className='deleteWarningTableLines'>
                            <span >
                                The analysis will be cleared for this table. This action is irreversible. Click ‘Confirm’ to apply.                        </span>
                        </div>
                    </React.Fragment>
                </MotifModalBody>
                <MotifModalFooter className='deleteWarningTableFooter'>
                    <React.Fragment key=".0">
                        <MotifButton
                            className='btnCancel '
                            label="btnCancel"
                            size="small"
                            type="button"
                            variant="secondary"
                            onClick={onClose}
                        >
                            Cancel
                        </MotifButton>
                        <MotifButton
                            label="btnConfirm"
                            size="small"
                            type="button"
                            variant="primary"
                            className='btnConfirm'
                            onClick={() => {
                                handleClearTableAnalysis();
                                clearTableAnalysisFromExcel();
                            }}
                        >
                            Confirm
                        </MotifButton>
                    </React.Fragment>
                </MotifModalFooter>
            </MotifModal>
        </div>
    );
};

ClearTableAnalysis.propTypes = {
    onClose: PropTypes.func,
    handleClearTableAnalysis: PropTypes.func,
    clearTableAnalysisFromExcel: PropTypes.func
};

export default ClearTableAnalysis;